window.$ = window.jQuery = require('jquery');

require('bootstrap/dist/js/bootstrap.min');
require('vgnav/dist/js/vgnav.min');
require('ion-rangeslider/js/ion.rangeSlider.min');
require('../../vendor/vegas/form-sender/js/jquery.inputmask');
require('../../vendor/vegas/form-sender/js/jquery.vegasFormSender');
require('../../vendor/vegas/form-sender/js/alert.vegasFormSender');
require('../../vendor/vegas/cnt-el/jquery.vegasCountElements');
require('../../vendor/vegas/sidebar/jquery.vegasSidebar');
require('../../vendor/vegas/scrollTo/jquery.vegasScrollTo');
require('../../vendor/vegas/dropdown/jquery.vegasDropdown');

require('../vendor/owl/owl.carousel');
require('../../vendor/fancybox/jquery.fancybox');
require('../vendor/plugins/js/jquery.nice-select');
require('../vendor/plugins/js/jquery.paroller.min');
require('../vendor/plugins/js/parallax.min');
require('../vendor/slick/slick');
require('../../vendor/modules/functions');
require('./modules/parallax');

require('./modules/vegas');
require('./modules/functions');
require('./modules/ym');
require('./modules/search');
require('./modules/shop/cart');

require('./modules/shop/order/vegas_order');
require('./modules/shop/order/listeners');
require('./modules/shop/order/delivery_courier');
require('./modules/shop/order/delivery_cdek_courier');
require('./modules/shop/order/delivery_cdek_pickup');
require('./modules/shop/order/delivery_boxberry_pickup');
require('./modules/shop/order/delivery_boxberry_courier');
require('./modules/shop/order/oneclick');

require('./modules/shop/fav');
require('./modules/shop/compare');
require('./modules/shop/images');
require('./modules/shop/filters');
require('./modules/shop/weightable');
require('./modules/shop/product');
require('./modules/catalog');
require('./modules/comments');
require('./modules/poll');
require('./modules/auth');

// [[vegas]]

require('./custom');